export const SUBSCRIPTION_SOURCE_UUID_KEY = 'sourceSubscriptionUuid';
export const shopSubdomainBase = `https://shop.${process.env.NEXT_PUBLIC_BACKEND_DOMAIN}`;
const availableLocales = process.env.LOCALES?.split(',') || [];

function normalizeLocale(locale: string) {
  if (locale.startsWith('en')) {
    return '';
  } else {
    return locale;
  }
}

function hasLocaleString(path: string) {
  return availableLocales.some((locale) => path.includes(`/${locale}/`));
}

function appendLocale(path: string, locale: string) {
  if (hasLocaleString(path)) {
    return path;
  } else {
    return `${locale}${path}`;
  }
}

function buildPath(path: string, locale: string) {
  const normalizedLocale = normalizeLocale(locale);

  return appendLocale(path, normalizedLocale);
}

export default function buildShopSubdomainUrl(path: string, locale: string) {
  if (!path.startsWith('/')) {
    return path;
  }
  try {
    new URL(path, shopSubdomainBase).href; // throws if path is invalid, URL.canParse() is not yet supported

    const localizedPath = buildPath(path, locale);
    return new URL(localizedPath, shopSubdomainBase).href;
  } catch (_) {
    return path;
  }
}

export function constructLegacyCustomerPortalLink(
  locale: string | undefined,
  segments: string[],
  queryString?: string,
) {
  const shopBaseUrl = buildShopSubdomainUrl('/account/#/', locale as string);

  return `${shopBaseUrl}${segments.join('/')}${queryString ? queryString : ''}`;
}

export type QueryParameter = {
  key: string;
  value: string | number | boolean;
};

export function buildQueryString(queryParameters: QueryParameter[] = []) {
  if (queryParameters.length === 0) {
    return '';
  }

  const formattedQueryParameters = queryParameters.map(
    (queryParameter) =>
      `${encodeURIComponent(queryParameter.key)}=${encodeURIComponent(
        queryParameter.value,
      )}`,
  );

  return `?${formattedQueryParameters.join('&')}`;
}

export function buildRelativeInternalUrl(
  segments: string[],
  queryString?: string,
) {
  return `/${segments.join('/')}${queryString || ''}`;
}

export const replaceQueryStringParam = (
  url: string,
  param: string,
  newValue: string,
) => {
  const regex = new RegExp(`([?&])${param}[^&]*`);

  const newUrl = url.match(regex)
    ? url.replace(regex, `$1${param}=${newValue}`)
    : `${url}?${param}=${newValue}`;

  return newUrl;
};
